// action - state management
import { REGISTER, LOGIN, LOGOUT, UPDATE_USER } from "./actions";

// types
import { AuthProps, AuthActionProps } from "types/auth";

// initial state
export const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action: AuthActionProps) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload!;
      return {
        ...state,
        user,
      };
    }
    case LOGIN: {
      const { user, twoFactorAuth, isLoggedIn } = action.payload!;
      return {
        ...state,
        isLoggedIn: isLoggedIn,
        isInitialized: true,
        twoFactorAuth,
        user,
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        twoFactorAuth: false,
        user: null,
      };
    }
    case UPDATE_USER: {
      const { user } = action.payload!;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user: user,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
